/**
 *   Name: SidebarNav.js
 * Author: Francisco J. O'Meany
 * Description: SidebarNav class component for all dashboard applications developed by Netequal Technology Solutions & Vysel
 *
 * Copyright (c) 2024 - Netequal Technology Solutions
 *
 */
import React from 'react';
import { Sidebar, Menu, MenuItem, SubMenu } from 'react-pro-sidebar';
import { Routes, Route, Link } from "react-router-dom";
import { FormattedMessage } from 'react-intl';
import Utility from '../Utility/Utility.js';
import MenuRoundedIcon from "@mui/icons-material/MenuRounded";
import ManageAccountsIcon from '@mui/icons-material/ManageAccounts';
import ReceiptRoundedIcon from "@mui/icons-material/ReceiptRounded";
import BarChartRoundedIcon from "@mui/icons-material/BarChartRounded";
import TimelineRoundedIcon from "@mui/icons-material/TimelineRounded";
import BubbleChartRoundedIcon from "@mui/icons-material/BubbleChartRounded";
import WalletRoundedIcon from "@mui/icons-material/WalletRounded";
import AccountBalanceRoundedIcon from "@mui/icons-material/AccountBalanceRounded";
import SavingsRoundedIcon from "@mui/icons-material/SavingsRounded";
import MonetizationOnRoundedIcon from "@mui/icons-material/MonetizationOnRounded";
import SettingsApplicationsRoundedIcon from "@mui/icons-material/SettingsApplicationsRounded";
import AccountCircleRoundedIcon from "@mui/icons-material/AccountCircleRounded";
import ShieldRoundedIcon from "@mui/icons-material/ShieldRounded";
import NotificationsRoundedIcon from "@mui/icons-material/NotificationsRounded";
import LanguageIcon from '@mui/icons-material/Language';
import LogoutRoundedIcon from "@mui/icons-material/LogoutRounded";
import { Home, Dashboard, Transactions } from './MenuItems.js';
import jQuery from 'jquery';
import './SidebarNav.css';
import 'bootstrap/dist/css/bootstrap.min.css';

import Accounts from '../Accounts/Accounts.js';
import Translations from '../Translations/Translations.js';

class SidebarNav extends React.Component {
    constructor(props) {
        super(props);
        this.Utl    = new Utility();																			//- Get an instance of our Utility class
        this.lang   = this.Utl.getCookie("appLang");
        this.state  = { isCollapsed: false, sbWidth: 80 };
        this.sbWidth = 80;
        this.mounted = false;
    }

    setCollapsed = () => {
        const self = this;
        this.setState( { isCollapsed: !this.state.isCollapsed } );

        const sbRect = this.sbDv.getBoundingClientRect();
        const chRect = this.sbEl.getBoundingClientRect();

        this.Utl.appLogger("Sidebar width: ", sbRect );
        this.Utl.appLogger("Sidebar child: ", chRect );
        this.Utl.appLogger("isCollapsed? ", this.state.isCollapsed );

        if( !this.state.isCollapsed ) {
            this.sbDv.style.width = "80px";
            this.sbEl.style.width = "80px";
            this.sbWidth = sbRect.width;
            this.setState( { sbWidth: sbRect.width } );
        } else {
            self.sbEl.style.width = self.state.sbWidth + "px";
            self.sbDv.style.width = self.state.sbWidth + "px";
        }

        this.Utl.appLogger("this.sbWidth: ", this.state.sbWidth );
    }

    handleLanguage( event ) {																					//- Handle language selection
        let Utl = new Utility();																				//- Get an instance of our Utility class
        let lng = Utl.getCookie( "appLang" );																	//- Get previous language selection
        let language = ( lng === 'en' ? 'es' : 'en' );															//- If English set Spanish otherwise set English language
        Utl.setCookie( "appLang", language, 30 );																//- Set current language selection
        document.location.reload()																				//- Reload page
        event.preventDefault();																					//- Prevent default
    }

    showSideBarSize = () => {
        const sbRect = this.sbDv.getBoundingClientRect();
        this.sbEl.style.width = sbRect.width + "px";
        document.removeEventListener('mouseup', this.stopDrag, false);
    }

    initDrag = () => {
        document.addEventListener('mouseup', this.showSideBarSize, false);
    }

    componentDidMount() {
        const self		= this;	                                                                                //- Set self as our class for future reference
        document.addEventListener('readystatechange', function() {												//- Add a 'readystatechange' event listener
			if (document.readyState === 'complete') {															//- When the readyState is completed
				if( !self.mounted ) {																			//- When component is mounted
                    self.sbDv = document.getElementById("appSideBar");
                    self.sbEl = document.getElementsByClassName("ps-sidebar-container")[0];

                    self.sbDv.style.backgroundColor = "#cfe2ff";
                    self.sbEl.style.backgroundColor = "#cfe2ff";
                        
                    self.sbWidth = self.sbDv.getBoundingClientRect();
                    self.sbEl.style.width = self.sbWidth.width + "px";
                    document.addEventListener('mousedown', self.initDrag, false);

                    self.Utl.appLogger('React app DOM loaded on SidebarNav component. Lang is: ', self.lang);	//- Log mounted event and show current language
                    //document.getElementsByTagName('title')[0].innerHTML = 
                    //( self.lang === 'en' ? 'Dashboard Home' : 'Página Princpal del Panel' );					//- Set page title with business information

                    //document.getElementsByTagName('title')[0].innerHTML = document.getElementById("appAdminTitle").innerHTML;
                    

                    document.getElementsByTagName('html')[0].setAttribute("lang", self.lang);                   //- Set page language
                    self.login = JSON.parse(localStorage.getItem('login'));
                    self.mounted = true;                                                                        //- This component has been mounted and completed
                    self.Utl.appLogger( "login appears to be: ", self.login );


                    

                    
                    let readyTimer = setInterval(function() {
                        if( window.document.readyState === "complete" ) {
                            document.getElementsByTagName('title')[0].innerHTML = document.getElementById("appAdminTitle").innerHTML;
                            self.Utl.appLogger( "Document ready state: ", window.document.readyState );
                            clearInterval( readyTimer );
                        }
                    }, 500);
                    


                    
                    if( self.login === null ) {                                                                 //- If login is not available
                        jQuery( "#appMenuItems" ).hide();                                                       //- Hide menu items
                    } else {                                                                                    //- Otherwise
                        jQuery( "#appLogout" ).on( 'click tap', function( event ) {                             //- Listen to the logout event
                            event.stopImmediatePropagation();                                                   //- Stop propagation
                            self.Utl.appLogger( "Logout button pressed" );
                            localStorage.removeItem( "login" );                                                 //- Remove "login" item from store
                            window.location = "/";                                                              //- Redirect to home location
                        });
                    }

                    if( document.getElementById("usr_email") ) {                                                //- If user email field is visible
                        document.getElementById("usr_email").focus();                                           //- Focus on user email field

                        jQuery('#usr_email, #usr_pwd').on('cut paste keyup change', function (event) {          //- Listen to "cut paste keyup change" events
                            event.stopImmediatePropagation();                                                   //- Stop propagation
                            const email = document.getElementById( "usr_email" ).value;                         //- Get user email value
                            const pwd = document.getElementById("usr_pwd").value;                               //- Get password value
                            self.Utl.appLogger( "login event: ", event );
    
                            if( self.Utl.validateEmail( email ) && pwd.length > 4 ) {                           //- If fields are validated
                                jQuery( "#appLoginBtn" ).removeClass( "disabled" );                             //- Enable login button
                            } else {                                                                            //- Otherwise
                                jQuery( "#appLoginBtn" ).addClass( "disabled" );                                //- Disable login button
                            }

                            if ( (  event.originalEvent.key === 'Enter' ||                                      //- If the event key is "Enter" or
                                    event.originalEvent.keyCode === 13 ) &&                                     //- event key code equal 13 (ASCII Enter key) and
                                    ( self.Utl.validateEmail( email ) && pwd.length > 4 ) ) {                   //- user email and password fields are validated then
                                document.getElementById( "appLoginBtn" ).click();                               //- Click the "Submit" button
                            }
                        });
    
                        jQuery( "#appLoginBtn" ).on( 'click tap', function( event ) {                           //- If "Submit" button is pressed
                            event.stopImmediatePropagation();                                                   //- Stop propagation
                            const email = document.getElementById( "usr_email" ).value;                         //- Get email value
                            const pwd = btoa( document.getElementById("usr_pwd").value );                       //- Get password value
                            const loginInfo = { "email": email, "pwd": pwd };                                   //- Set login information
                            const adminDir = JSON.parse(localStorage.getItem('appDirs'));                       //- Get app directories information
                            const server = adminDir.admin + "/api/appAgent.php";                                //- Get server location depending on Dev/Production
                            self.Utl.appLogger( "adminDir: ", adminDir );

                            jQuery.ajax({                                                                       //- Send server validation data
                                url:server,                                                                     //- Server script
                                type:'post',                                                                    //- POST type
                                data: { "method":15, "usr_email": email, "usr_pwd": pwd },                      //- Send data
                                dataType:'json',                                                                //- Make it JSON type
                                success: function( data ) {                                                     //- On success
                                    self.Utl.appLogger( "Login validation data: ", data );

                                    if( data.status ) {                                                         //- If success validation
                                        const logTime = new Date().getTime();                                   //- Get current date and time
                                        localStorage.setItem('login',                                           //- Set "login" storage item
                                                    JSON.stringify({email: loginInfo.email, pwd: loginInfo.pwd, log_time: logTime}));
                                        self.login = JSON.parse(localStorage.getItem('login'));                 //- Set the current login info and
                                        jQuery( "#appMenuItems" ).show();                                       //- Show menu items
                                        window.location = "/";                                                  //- Redirect to home location
                                        window.location.reload();                                               //- Reload page
                                    } else {                                                                    //- Otherwise report error
                                        switch( data.reason ) {
                                            case 0:
                                                break;
                                            case 1:
                                                break;
                                            case 2:
                                                break;
                                            case 3:
                                                break;
                                            case 4:
                                                break;
                                            default:
                                                break;
                                        }

                                    }
                                },
                                error: function(  jqXHR, textStatus, errorThrown  ){
                                    let errMsg = 'Login validation data Network failure: '+textStatus+" ("+errorThrown+")";
                                    self.Utl.appLogger( errMsg );
                                },
                                complete: function(){
                                    self.Utl.appLogger( 'Login validation data completed', "");
                                }
                            });

                            

                            


    
                            /*
                            localStorage.setItem('login', JSON.stringify(loginInfo));
                            self.login = JSON.parse(localStorage.getItem('login'));
                            self.Utl.appLogger( "Login: ", self.login );
    
                            jQuery( "#appMenuItems" ).show();
                            
                            window.location = "/";
                            window.location.reload();
                            */
    
                            //const navigate = useNavigate();
                            //navigate( "/accounts" );
    
                            //- btoa( pwd ) to encode
                            //- atob( enc ) to decode
    
                        });
                    }
                    
                    document.getElementById("appSideBarMenu").addEventListener("click", () => {
                        let timerId = setInterval(function() {
                            if( document.getElementById("usr_email") ) {
                                document.getElementById("usr_email").focus();
                            }
                            clearInterval(timerId);
                        }, 250);
                    });

                }

            }
        });
    }

    render() {
        const self = this;
        self.login = JSON.parse(localStorage.getItem('login'));
        this.Utl.appLogger( "Self: ", self.login );
        this.Utl.appLogger( "Props:", this.props );
        return(
            <>
            <div id="appAdminTitle" className='d-none'><FormattedMessage id = "app-admin-title" defaultMessage="Title" /></div>
            <div id="appDeleteTitle" className='d-none'><FormattedMessage id = "app-delete-title" defaultMessage="Delete" /></div>
            <div id="appYesText" className='d-none'><FormattedMessage id = "app-yes-text" defaultMessage="Yes" /></div>
            <div id="appKeyExistsText" className='d-none'><FormattedMessage id = "app-key-exists-text" defaultMessage="Exists" /></div>
            <div id="appErrorText" className='d-none'><FormattedMessage id = "app-error-text" defaultMessage="Error" /></div>
        
            

            


            
            <div style={{ display: "flex", height: "100vh", position: 'relative' }}>
            <Sidebar id="appSideBar" className="app" collapsed={this.state.isCollapsed} width={"300px"}>
                <Menu id="appTranslatedMsgs">
                    
                </Menu>
                <Menu id="appSideBarMenu">
                    <MenuItem
                        component={<Link to="/" className="link" />}
                        className="menu1"
                        icon={
                        <MenuRoundedIcon
                            onClick={() => {
                            this.setCollapsed();
                            }}
                        />
                        }
                    >
                    <h2>Vysel</h2>
                    </MenuItem>
                    <div id="appMenuItems">
                    <MenuItem
                        id="appAccountsLink"
                        component={<Link to="accounts" className="link" />}
                        icon={<ManageAccountsIcon />}
                    >
                        <FormattedMessage
                            id = "app-dash-accounts"
                            defaultMessage="Accounts"
                        />
                    </MenuItem>
                    <MenuItem icon={<ReceiptRoundedIcon />}>
                        <FormattedMessage
                            id = "app-dash-invoices"
                            defaultMessage="Invoices"
                        />
                    </MenuItem>
                    <SubMenu label={
                        <FormattedMessage
                            id = "app-dash-current-charts"
                            defaultMessage="Charts"
                        />
                        }
                        icon={<BarChartRoundedIcon />}>
                        <MenuItem icon={<TimelineRoundedIcon />}> Timeline Chart </MenuItem>
                        <MenuItem icon={<BubbleChartRoundedIcon />}>Bubble Chart</MenuItem>
                    </SubMenu>
                    <SubMenu label={
                        <FormattedMessage
                            id = "app-dash-current-wallets"
                            defaultMessage="Wallets"
                        />
                        }
                        icon={<WalletRoundedIcon />}>
                        <MenuItem icon={<AccountBalanceRoundedIcon />}>
                            <FormattedMessage
                                id = "app-dash-current-wallet"
                                defaultMessage="Current Wallet"
                            />
                        </MenuItem>
                        <MenuItem icon={<SavingsRoundedIcon />}>
                            <FormattedMessage
                                id = "app-dash-savings-wallet"
                                defaultMessage="Savings Wallet"
                            />
                        </MenuItem>
                    </SubMenu>
                    <MenuItem
                        component={<Link to="transactions" className="link" />}
                        icon={<MonetizationOnRoundedIcon />}
                    >
                        <FormattedMessage
                            id = "app-dash-transactions"
                            defaultMessage="Transactions"
                        />
                    </MenuItem>
                    <SubMenu label={
                        <FormattedMessage
                            id = "app-dash-settings"
                            defaultMessage="Settings"
                        />
                        }
                        icon={<SettingsApplicationsRoundedIcon />}>
                        <MenuItem icon={<AccountCircleRoundedIcon />}>
                            <FormattedMessage
                                id = "app-dash-account"
                                defaultMessage="Account"
                            />
                        </MenuItem>
                        <MenuItem icon={<ShieldRoundedIcon />}>
                            <FormattedMessage
                                id = "app-dash-privacy"
                                defaultMessage="Privacy"
                            />
                        </MenuItem>
                        <MenuItem icon={<NotificationsRoundedIcon />}>
                            <FormattedMessage
                                id = "app-dash-notifications"
                                defaultMessage="Notifications"
                            />
                        </MenuItem>
                        <MenuItem 
                            component={<Link to="translations" className="link" />}
                            icon={<LanguageIcon />}
                        >
                            <FormattedMessage
                                id = "app-dash-translations"
                                defaultMessage="Translations"
                            />
                        </MenuItem>
                    </SubMenu>
                    
                    <MenuItem 
                        id="appLogout"
                        icon={<LogoutRoundedIcon />}
                    >
                        <FormattedMessage
                            id = "app-dash-logout"
                            defaultMessage="Logout"
                        />
                    </MenuItem>
                    </div>
                    <MenuItem icon={<LanguageIcon />} onClick={this.handleLanguage}> 
                            {( this.lang === "en" ? "Español" : "English" )}
                    </MenuItem>
                </Menu>
            </Sidebar>
            
            <section className='w-100 overflow-scroll m-3'>
                <Routes>
                <Route path="/" element={<Home login={ ( self.login === null ? {email: null, pwd: null} : self.login ) } />} />
                <Route path="dashboard" element={<Dashboard />} />
                <Route path="accounts" element={<Accounts />} />
                <Route path="transactions" element={<Transactions />} />
                <Route path="translations" element={<Translations />} />
                </Routes>
            </section>
            </div>
            </>
        );
    }
}

export default SidebarNav;